<template>
    <div>
        <app-template>
            <div class="bg-white p-4 rounded shadow">
                <chantier-view :chantier-id="$route.params.id" @chantier-ended="handleChantierEnded" />
            </div>
        </app-template>
    </div>
</template>

<script>
import ChantierView from './Components/ChantierView.vue'

export default {
    components: {
        ChantierView
    },
    methods: {
        handleChantierEnded() {
            this.$toast.success('Le chantier a été marqué comme terminé !')
            window.location.href = '/app/chantiers'
        }
    },
}
</script>

<style lang="scss" scoped>

</style>